import React from 'react';

import {
  Box,
  FormControlLabel,
  Switch
} from '@mui/material';

import * as dataService from './dataService';



export interface IProps {
  onChangeLoading: (loading: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery();
  const [
    toggleAllAccess,
    toggleAllAccessTuple
  ] = dataService.useToggleAllAccess();



  React.useEffect(
    () => {
      props.onChangeLoading(queryTuple.loading);
    },
    [
      queryTuple.loading,
      props
    ]
  );

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      toggleAllAccess(checked);
    },
    [toggleAllAccess]
  );



  return queryTuple.loading ? null : (
    <Box>
      <FormControlLabel
        label="Enable All-access"
        control={(
          <Switch
            disabled={toggleAllAccessTuple.loading}
            defaultChecked={queryTuple.data.allAccessEnabled}
            onChange={handleChange}
          />
        )} />
    </Box>
  );
};
